import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {AsyncPipe, LowerCasePipe, NgClass, NgIf, UpperCasePipe} from "@angular/common";
import {NgClickOutsideDirective} from "ng-click-outside2";
import {LetDirective} from "@directives/app-let.directive";
import {CulturePipe, CulturePipeTransformType} from "@pipes/culture/culture.pipe";
import {GrowthBookFeatureKeys} from "@models/growthbook.models";
import {GrowthBookService} from "@services/growthbook/growthbook.service";
import {CollapseModule} from "ngx-bootstrap/collapse";
import {CULTURE_FRENCH, CULTURE_US, CultureKeyType, SECONDS_PER_DAY} from "@constants/app.constants";
import {CookieStorageService} from "@services/cookie-storage/cookie-storage.service";
import {Router} from "@angular/router";
import {CultureResource} from "@models/resources/culture.model";
import {selectCultures, selectHeaderOrderedCultures} from "@selectors/resource.selector";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-culture-dropdown',
  standalone: true,
  imports: [
    NgClass,
    NgClickOutsideDirective,
    LetDirective,
    AsyncPipe,
    CulturePipe,
    UpperCasePipe,
    LowerCasePipe,
    NgIf,
    CollapseModule
  ],
  templateUrl: './culture-dropdown.component.html',
  styleUrl: './culture-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CultureDropdownComponent implements OnInit {
  @Input() collapseCultures: boolean;
  @Input() alignToLeft: boolean = false;
  @Input() cultureCode: string | null | undefined;
  @Input() cultureName: string | null;

  cultures$: Observable<CultureResource[] | null>;

  constructor(public gbs: GrowthBookService,
              private cookieStorageService: CookieStorageService,
              private router: Router,
              private store: Store,
              ) {
  }

  ngOnInit() {
    this.loadCultures();
  }

  private loadCultures() {
    if (this.gbs.growthBook.isOn(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER) && this.gbs.growthBook.getFeatureValue(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER, '') !== 'a') {
      this.cultures$ = this.store.select(selectHeaderOrderedCultures);
    } else {
      this.cultures$ = this.store.select(selectCultures);
    }
  }

  changeCulture(
    newCulture: CultureKeyType,
    currentCulture: string | null | undefined,
  ): void {
    if (newCulture === currentCulture) {
      return;
    }
    this.collapseCultures = true;

    this.cookieStorageService.setItem(
      CookieStorageService.cookieCulture,
      newCulture,
      180 * SECONDS_PER_DAY,
    );

    this.router.navigateByUrl(
      this.router.url.replace(`/${currentCulture}`, `/${newCulture}`),
    );
  }

  cultures(data: CultureResource[] | null): CultureResource[] | null {
    if (this.gbs.isVariantOfExperimentEnabled('feat-002389-turning-off-cultures', 'b')) {
      return data?.filter(culture => culture.cultureCode === CULTURE_US || culture.cultureCode === CULTURE_FRENCH) || [];
    } else {
      return data;
    }
  }

  protected readonly CulturePipeTransformType = CulturePipeTransformType;
  protected readonly GrowthBookFeatureKeys = GrowthBookFeatureKeys;
}
